const toggleSidebar = (context) => {
  context.commit('TOGGLE_SIDEBAR');
}

const addShape = (context, payload) => {
  context.commit('ADD_SHAPE', payload);
}

const removeAllShape = (context) => {
  context.commit('REMOVE_ALL_SHAPE');
}

const setCurrentImage = (context, payload) => {
  context.commit('SET_CURRENT_IMAGE', payload);
}

const addSeatToStore = (context, payload) => {
  context.commit('ADD_SEATS', payload);
}

const setCurrentSeatImage = (context, payload) => {
  context.commit('SET_CURRENT_SEAT_IMAGE', payload);
}

export default {
  toggleSidebar,
  addShape,
  setCurrentImage,
  removeAllShape,
  addSeatToStore,
  setCurrentSeatImage
}